export default __webpack_public_path__ + "assets/webgl/picking-6.9384ab3a.glb";